export const FETCH_TRAINER_DETAILS = 'FETCH_TRAINER_DETAILS'
export const FETCH_TRAINER_DETAILS_SUCCESS = 'FETCH_TRAINER_DETAILS_SUCCESS'
export const FETCH_TRAINER_DETAILS_FAILURE = 'FETCH_TRAINER_DETAILS_FAILURE'
